exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiselect-td[data-v-962bc388] {\n    padding: 2px 10px;\n}\n.multiselect[data-v-962bc388] {\n    min-height: 28px;\n}\n", ""]);

// exports
